import { render, staticRenderFns } from "./dispatchplanv98.vue?vue&type=template&id=a2e0a45c&scoped=true"
import script from "./dispatchplanv98.vue?vue&type=script&lang=js"
export * from "./dispatchplanv98.vue?vue&type=script&lang=js"
import style0 from "./dispatchplanv98.vue?vue&type=style&index=0&id=a2e0a45c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e0a45c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
